import { gql } from 'graphql-tag'

/**
 * The unified INBOX — one round-trip for the whole page:
 * `{ missedCalls, cases, staff, contacts, unknown, totals }`, where each
 * entity card carries BOTH its unread messages and its unseen notes.
 */
export const UNIFIED_INBOX_QUERY = gql`
  query GetUnifiedInbox($noteLimit: Int, $includeHandledCallsToday: Boolean) {
    getUnifiedInbox(
      noteLimit: $noteLimit
      includeHandledCallsToday: $includeHandledCallsToday
    )
  }
`
